\rtr-cart-item-total-price
    display: inline
    font-size: .75rem
    font-weight: 400
